<template>
  <vp-tooltip v-if="spamComplaintEmails.length" class="spam-complaint-email-tooltip" icon="exclamation" :iconStyles="{color: '#F5D873'}" v-bind="tooltipProps">
    <template #header>
      <div class="spam-complaint-email-tooltip__header">
        <p>{{ 'Delivery Blocked As Spam' }}</p>
      </div>
    </template>
    <template #default>
      <div class="spam-complaint-email-tooltip__content">
        <ul>
          <li v-for="email in spamComplaintEmails" :key="`spam-complaint-${email}`">
            <p>{{ email }}</p>
          </li>
        </ul>
        <p>
          {{ `${spamComplaintEmails.length > 1 ? 'These' : 'This'} email${spamComplaintEmails.length > 1 ? 's' : ''} ${spamComplaintEmails.length > 1 ? 'are' : 'is'} marked as spam and unable to receive messages.` }}
        </p>
        <p>
          {{ `Please contact the homeowner for ${spamComplaintEmails.length > 1 ? '' : 'a'} new email address${spamComplaintEmails.length > 1 ? 'es' : ''}.` }}
        </p>
      </div>
    </template>
  </vp-tooltip>
</template>

<script>
import VpTooltip from './VpTooltip.vue';
export default {
  name: 'SpamComplaintEmailTooltip',
  components: {
    VpTooltip,
  },
  props: {
    spamComplaintEmails: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    tooltipProps() {
      return {
        offset: [-50, 10],
        placement: 'bottom',
        fallbackPlacements: ['top', 'right'],
        enableScrolling: true,
        styles: {
          minWidth: '187px',
          width: 'unset',
          maxWidth: '300px',
          maxHeight: '425px',
          borderRadius: '6px',
          arrow: { bottom: { color: '#F4F7F8' } },
        },
      };
    },
  },
};
</script>

<style lang="scss">
@import '../../styles/colors.scss';

.spam-complaint-email-tooltip {
  ul {
      margin: 0;
      padding: 0 1rem;
    }
    p {
      font-size: 0.75rem;
      margin: 0;
    }
  &__header {
    padding: 9px 16px 7px;
    background-color: $backgroundgray;
    border-bottom: 1px solid $lightgray;
    border-radius: 6px 6px 0 0;
    p {
      color: $darkblue;
      font-size: 10px;
      font-weight: bold;
      text-transform: uppercase;
    }
  }
  &__content {
    padding: 1rem;
    list-style: none;
    row-gap: .5rem;
    display: flex;
    flex-direction: column;
  }
}
</style>
